/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum RichTextPluginOptions {
    LISTS = 'lists',
    IMAGE = 'image',
    CHARMAP = 'charmap',
    TABLE = 'table',
    ADVLIST = 'advlist',
    LINK = 'link',
    AUTORESIZE = 'autoresize',
    SAVE = 'save',
}
